/* Superdil redesign — header (sections/sd-header.liquid). Vanilla JS, fără dependențe.
 * - starea sticky (umbră) + variabila --sd-sticky-h pentru alte elemente sticky
 * - bara de categorii: săgeți de scroll pe desktop
 * - panoul „Toate categoriile” (deschis/închis, Esc, click în afară)
 * - căutarea pe mobil (iconița lupă deschide câmpul)
 * - bara utilitară: pauză la atingere (marquee pe mobil)
 */
(() => {
  'use strict';

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function initHeader(header) {
    if (header.dataset.sdReady) return;
    header.dataset.sdReady = 'true';

    const section = header.closest('.shopify-section') || header;
    const util = header.querySelector('[data-sd-util]');

    /* --- sticky: umbră + înălțimea părții fixe --- */
    const setStickyHeight = () => {
      const utilH = util ? util.offsetHeight : 0;
      section.style.setProperty('--sd-util-h', `${utilH}px`);
      document.documentElement.style.setProperty('--sd-sticky-h', `${header.offsetHeight - utilH}px`);
    };
    setStickyHeight();
    if ('ResizeObserver' in window) new ResizeObserver(setStickyHeight).observe(header);

    let ticking = false;
    const onScroll = () => {
      const threshold = util ? util.offsetHeight : 1;
      header.classList.toggle('is-stuck', window.scrollY > threshold);
      ticking = false;
    };
    window.addEventListener(
      'scroll',
      () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(onScroll);
      },
      { passive: true }
    );
    onScroll();

    /* --- bara utilitară: pauză la atingere --- */
    if (util) {
      util.addEventListener('click', () => util.classList.toggle('is-paused'));
    }

    /* --- bara de categorii: săgeți --- */
    const list = header.querySelector('[data-sd-cats-list]');
    const prev = header.querySelector('[data-sd-cats-prev]');
    const next = header.querySelector('[data-sd-cats-next]');
    if (list && prev && next) {
      const updateArrows = () => {
        const max = list.scrollWidth - list.clientWidth - 2;
        prev.hidden = list.scrollLeft <= 2;
        next.hidden = list.scrollLeft >= max;
      };
      const scrollByPage = (dir) => {
        list.scrollBy({ left: dir * list.clientWidth * 0.7, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
      };
      prev.addEventListener('click', () => scrollByPage(-1));
      next.addEventListener('click', () => scrollByPage(1));
      list.addEventListener('scroll', () => requestAnimationFrame(updateArrows), { passive: true });
      if ('ResizeObserver' in window) new ResizeObserver(updateArrows).observe(list);
      updateArrows();

      // categoria curentă vizibilă în bară
      const current = list.querySelector('[aria-current="page"]');
      if (current) list.scrollLeft = Math.max(0, current.offsetLeft - list.clientWidth / 3);
    }

    /* --- panoul „Toate categoriile” --- */
    const toggle = header.querySelector('[data-sd-allcats-toggle]');
    const panel = header.querySelector('[data-sd-allcats]');
    const closeBtn = header.querySelector('[data-sd-allcats-close]');
    if (toggle && panel) {
      const isOpen = () => toggle.getAttribute('aria-expanded') === 'true';
      const open = () => {
        const nav = header.querySelector('[data-sd-cats]');
        const bottom = nav ? nav.getBoundingClientRect().bottom : 0;
        panel.style.setProperty('--sd-panel-top', `${Math.max(0, bottom)}px`);
        panel.hidden = false;
        toggle.setAttribute('aria-expanded', 'true');
        header.classList.add('is-allcats-open');
        document.addEventListener('keydown', onKey);
        document.addEventListener('click', onOutside, true);
      };
      const close = (returnFocus) => {
        panel.hidden = true;
        toggle.setAttribute('aria-expanded', 'false');
        header.classList.remove('is-allcats-open');
        document.removeEventListener('keydown', onKey);
        document.removeEventListener('click', onOutside, true);
        if (returnFocus) toggle.focus();
      };
      const onKey = (event) => {
        if (event.key === 'Escape') close(true);
      };
      const onOutside = (event) => {
        if (!panel.contains(event.target) && !toggle.contains(event.target)) close(false);
      };
      toggle.addEventListener('click', () => (isOpen() ? close(false) : open()));
      if (closeBtn) closeBtn.addEventListener('click', () => close(true));
    }

    /* --- căutare pe mobil --- */
    const searchToggle = header.querySelector('[data-sd-search-toggle]');
    const search = header.querySelector('[data-sd-search]');
    if (searchToggle && search) {
      const input = search.querySelector('input[type="search"]');
      const closeSearch = () => {
        header.classList.remove('is-search-open');
        searchToggle.setAttribute('aria-expanded', 'false');
        searchToggle.setAttribute('aria-label', 'Deschide căutarea');
      };
      searchToggle.addEventListener('click', () => {
        const willOpen = !header.classList.contains('is-search-open');
        if (!willOpen) return closeSearch();
        header.classList.add('is-search-open');
        searchToggle.setAttribute('aria-expanded', 'true');
        searchToggle.setAttribute('aria-label', 'Închide căutarea');
        if (input) setTimeout(() => input.focus(), 30);
      });
      search.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && header.classList.contains('is-search-open')) {
          closeSearch();
          searchToggle.focus();
        }
      });
    }
  }

  const initAll = () => document.querySelectorAll('[data-sd-header]').forEach(initHeader);
  initAll();
  // Editorul de temă reîncarcă secțiunea după modificări.
  document.addEventListener('shopify:section:load', initAll);
})();
